import Component from 'flarum/common/Component';
import PostPreview from 'flarum/forum/components/PostPreview';
export default class WarningPost extends Component {
  view() {
    return m("div", {
      className: "WarningPost"
    }, m("ul", {
      className: "Dropdown-menu PostPreview-preview fade in"
    }, m("li", null, PostPreview.component({
      post: this.attrs.post
    }))));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.$('.PostPreview-preview').show().css('position', 'relative');
  }
}
flarum.reg.add('fof-moderator-warnings', 'forum/components/WarningPost', WarningPost);